import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { LoginForm } from '@/features/auth/components/LoginForm';
import { Toaster } from 'sonner';

export function Login() {
  const { session, isInitialized } = useAuthStore();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');

  if (isInitialized && session) {
    return <Navigate to={redirect || '/dashboard'} replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <LoginForm />
      <Toaster position="top-right" />
    </div>
  );
}
